import React, { useEffect, useRef, useState } from "react";
import SidebarItem from "./sidebar-item";
import { Link, useLocation } from "react-router-dom";
import { Image } from "react-bootstrap";
import {
  SidebarContent,
  ConfigurationContent,
  getOrganizationSideBarContent,
  getOrganizationConfigurationContent,
  getOrganizationGalleryContent,
  getOrganizationThemeConfigurationContent,
  ThemeConfigurationContent,
} from "./sidebar-content";
import logoBlack from "../../assets/images/logo/logo.svg";
import {
  SettingIcon,
  ArrowRight02Icon2,
  ThemeConfigurationIcon,
} from "../../assets/icons";
import "./sidebar.css";

export default function Sidebar({ className }) {
  const [scrolled, setScrolled] = useState(false);
  const sidebarRef = useRef(null);

  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isOrganizationRoute =
    pathSegments.length > 1 && pathSegments[0] === "organization";
  const selectedOrganizationId = isOrganizationRoute ? pathSegments[1] : null;

  const handleSidebarScroll = () => {
    const scrollPosition = sidebarRef.current.scrollTop;

    if (scrollPosition > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (sidebar) {
      sidebar.addEventListener("scroll", handleSidebarScroll);
    }
    return () => {
      if (sidebar) {
        sidebar.removeEventListener("scroll", handleSidebarScroll);
      }
    };
  }, []);

  const isActive = (path) => {
    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/blog-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/blog-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/blogs`
    ) {
      return true;
    }
    if (
      (location.pathname === "/organization-add" ||
        location.pathname.startsWith("/organization-edit/")) &&
      path === "/organizations"
    ) {
      return true;
    }
    if (
      (location.pathname === "/template-add" ||
        location.pathname.startsWith("/template-edit/")) &&
      path === "/templates"
    ) {
      return true;
    }
    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/category-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/category-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/categories`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/child-category-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/child-categories`
        ) ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/sub-category-products`
        ) ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/sub-category-product-add/`
        ) ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/sub-category-product-edit`
        ) ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/child-category-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/categories`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/product-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/product-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/products`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/gallery-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/gallery-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/galleries`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/testimonial-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/testimonial-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/testimonials`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/client-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/client-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/clients`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/team-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/team-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/teams`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/target-region-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/target-region-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/target-regions`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/inquiry-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/inquiry-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/inquiries`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/page-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/page/`
        ) ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/page-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/pages`
    ) {
      return true;
    }

    if (
      (location.pathname ===
        `/organization/${selectedOrganizationId}/faq-add` ||
        location.pathname.startsWith(
          `/organization/${selectedOrganizationId}/faq-edit/`
        )) &&
      path === `/organization/${selectedOrganizationId}/faqs`
    ) {
      return true;
    }

    return location.pathname === path;
  };

  const selectedOrganization = localStorage.getItem(
    "selected-organization-data"
  );
  let selectedOrganizationData = null;
  if (selectedOrganization) {
    selectedOrganizationData = JSON.parse(selectedOrganization);
  }
  const selectedOrganizationType =
    selectedOrganizationData?.organization_type?.name;

  const currentSidebarContent = selectedOrganizationId
    ? getOrganizationSideBarContent(
        selectedOrganizationId,
        selectedOrganizationType
      )
    : SidebarContent;

  const currentConfigContent = selectedOrganizationId
    ? getOrganizationConfigurationContent(selectedOrganizationId)
    : ConfigurationContent;

  const currentGalleryContent = selectedOrganizationId
    ? getOrganizationGalleryContent(selectedOrganizationId)
    : SidebarContent;

  const currentThemeConfigContent = selectedOrganizationId
    ? getOrganizationThemeConfigurationContent(selectedOrganizationId)
    : ThemeConfigurationContent;

  return (
    <>
      <aside className={`bg-white ${className} sidebar`}>
        <div className="h-100 position-relative d-flex flex-column">
          <div className="flex-shrik-1 position-relative mt-3 mb-2">
            <div
              className={`d-flex align-items-center justify-content-center position-sticky top-0 start-0 end-0 site-logo ${
                scrolled ? "effect-logo" : null
              }`}
            >
              <Link to="/">
                <h1>
                  <Image src={logoBlack} />
                </h1>
              </Link>
            </div>
          </div>
          <div className="py-1 flex-grow-1 overflow-y-auto" ref={sidebarRef}>
            <ul className="mb-0 list-unstyled">
              {currentSidebarContent.map((item, i) => (
                <SidebarItem
                  key={i}
                  to={item.link}
                  icon={item.icon}
                  title={item.title}
                  dropdownIcon={item.dropdownIcon}
                  className={isActive(item.link) ? "active" : null}
                  children={
                    item.title === "Gallery"
                      ? currentGalleryContent
                      : item.children
                  }
                />
              ))}
            </ul>
            <ul className="mb-0 list-unstyled mt-2">
              <SidebarItem
                to="#"
                icon={
                  <SettingIcon
                    width={18}
                    height={18}
                    color="#444050"
                    strokeWidth="2"
                  />
                }
                dropdownIcon={
                  <ArrowRight02Icon2
                    width={18}
                    height={18}
                    color="#444050"
                    strokeWidth="2"
                  />
                }
                title="Configuration"
                children={currentConfigContent}
              />
            </ul>

            <ul className="mb-0 list-unstyled mt-3">
              {selectedOrganizationId && (
                <SidebarItem
                  to={`/organization/${selectedOrganizationId}/color-configuration`}
                  icon={
                    <ThemeConfigurationIcon
                      width={18}
                      height={18}
                      color="#444050"
                      strokeWidth="2"
                    />
                  }
                  title="Theme Configuration"
                  dropdownIcon={
                    <ArrowRight02Icon2
                      width={18}
                      height={18}
                      color="#444050"
                      strokeWidth="2"
                    />
                  }
                  children={currentThemeConfigContent}
                />
              )}
            </ul>
          </div>
        </div>
      </aside>
    </>
  );
}
